// extracted by mini-css-extract-plugin
module.exports = {"notification":"styles_notification__2fOv5","notification__title":"styles_notification__title__3lf6b","notification__statuses":"styles_notification__statuses__16k_7"};